export const getDocumentData = (document) => {
  // Повернення коштів студенту: касовий ордер type=common + income_expense=expense.
  // Показуємо як мінус (червоним), а не як зелений "+" продаж.
  const isRefund = document.type === 'common' && document.income_expense === 'expense';
  const common = !isRefund
    && (document.type === 'common' || (document.type === 'debt-correction' && document.income_expense === 'income'));
  const signs = common ? '+' : '-';
  const colorClass = common ? 'green' : 'red';
  const sumClasses = [colorClass].filter(Boolean).join(' ');

  return { common, signs, sumClasses, isRefund };
};

/**
 * Чи показувати кольорову крапку присутності.
 *
 * Списання занять (згорання за договором / ручне списання) технічно має attendance = 1,
 * але студент на занятті не був. Зелена крапка «був присутній» суперечила б підпису
 * «Списання згідно договору» — саме тієї плутанини ми й позбуваємось.
 *
 * ❗ Канон один на обидві в'юхи: таблиця (десктоп) і картка (мобільний). Саме через
 * дубльовану логіку вони вже розходились.
 */
export const showAttendanceStatus = (document) =>
  !!document.attendance_status && !document.is_lesson_write_off;

export const setStatusBg = (status) => {
  if (status === 1) {
    return 'bg-green';
  }

  if (status === 2) {
    return 'bg-yellow';
  }

  if (status === 3) {
    return 'bg-red';
  }

  return '';
};